import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiErr } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight, ArrowLeft, Loader2, Mail } from "lucide-react";
import BrandMark, { LogoFull } from "@/components/BrandMark";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Verifică-ți email-ul pentru instrucțiuni.");
    } catch (e) {
      toast.error(apiErr(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-ink-soft p-6">
      <div className="w-full max-w-md bg-white border border-neutral-200 p-10">
        <Link to="/login" className="inline-flex items-center gap-2 text-xs text-ink-muted hover:text-brand font-mono uppercase tracking-widest">
          <ArrowLeft className="h-3.5 w-3.5" /> Înapoi la autentificare
        </Link>
        <div className="mt-8">
          <LogoFull variant="dark" size="md" />
        </div>
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-brand mt-8 mb-2">— Resetare parolă</div>
        <h1 className="font-display font-black text-3xl md:text-4xl tracking-tight">Ai uitat parola?</h1>
        <p className="mt-3 text-ink-muted text-sm">Introduce email-ul contului tău și îți vom trimite link-ul de resetare.</p>

        {sent ? (
          <div className="mt-8 border border-green-200 bg-green-50 p-4 text-sm text-green-800" data-testid="forgot-sent">
            Dacă adresa există în sistem, vei primi un email cu link-ul de resetare în câteva minute.
          </div>
        ) : (
          <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="forgot-form">
            <div>
              <label className="font-mono text-[11px] uppercase tracking-widest text-ink-muted">Email</label>
              <div className="relative mt-2">
                <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-ink-muted" />
                <input
                  data-testid="forgot-email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-11 pr-4 py-3.5 border border-neutral-200 focus:border-brand focus:outline-none transition-colors"
                />
              </div>
            </div>
            <button data-testid="forgot-submit" disabled={busy} className="w-full btn-brand justify-center disabled:opacity-70">
              {busy ? <><Loader2 className="h-4 w-4 animate-spin" /> Se trimite</> : <>Trimite link <ArrowRight className="h-4 w-4" /></>}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
